

import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import ServersidePaging from "./ServersidePaging";

@Component({})

export default class ServersidePagingSelector extends Vue {
    @Prop({ required: true })
    paging!: ServersidePaging;

    @Prop({ default: false })
    belowTable!: boolean;

    @Prop({ default: false })
    small!: boolean;
}

